export default function initInteractive() {
    const components = document.querySelectorAll('.interactive');

    components.forEach((component) => {
        const wrapper = component.querySelector('.wrapper');
        const mainWrap = component.querySelector('.wrap');
        if (!mainWrap || !wrapper) return;

        const mainImg = mainWrap.querySelector(':scope > img');
        const items = component.querySelectorAll('.items .item');
        const detailImages = component.querySelectorAll('.images img');
        const popupsContainer = wrapper.querySelector('.interactive__popups');

        if (!popupsContainer) return;

        const infoBoxes = popupsContainer.querySelectorAll('.info');

        items.forEach((item, index) => {
            const dot = item.querySelector('.dot');
            const info = infoBoxes[index]; // Match by index

            if (!dot) return;

            // Positioning logic for dots
            const x = item.dataset.x;
            const y = item.dataset.y;

            if (x) {
                item.style.left = `${x}%`;
            }

            if (y) {
                item.style.top = `${y}%`;

                if (info) {
                    info.style.top = `${y - 5}%`;
                }
            }

            // Click logic
            dot.addEventListener('click', (e) => {
                e.stopPropagation();

                // Remove active from all detail images and info boxes
                detailImages.forEach((img) => img.classList.remove('active'));
                infoBoxes.forEach((itInfo) => {
                    itInfo.classList.remove('active');
                });

                // Toggle classes
                mainImg.classList.add('fade');
                if (detailImages[index]) {
                    detailImages[index].classList.add('active');
                }
                if (info) {
                    info.classList.add('active');
                }
            });
        });

        // Reset logic: click outside
        document.addEventListener('click', (e) => {
            const isDot = e.target.closest('.dot');
            if (!isDot) {
                mainImg.classList.remove('fade');
                detailImages.forEach((img) => img.classList.remove('active'));
                infoBoxes.forEach((itInfo) => {
                    itInfo.classList.remove('active');
                });
            }
        });
    });
}
